<script lang="ts" setup>
import { useSubscriptionStore } from '@entities/subscription'

import BannerFailed from './BannerFailed.vue'
import BannerProcessing from './BannerProcessing.vue'

defineOptions({
  name: 'BannerGroupRetryPayment',
})

const subscriptionStore = useSubscriptionStore()
</script>

<template>
  <BannerFailed
    v-if="subscriptionStore.isBannerPaymentRetry"
  />
  <BannerProcessing
    v-if="subscriptionStore.isBannerPaymentRetryProcessing"
  />
</template>
